import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore'
import { getMessaging, isSupported } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

const app = initializeApp(firebaseConfig)

export { app }
export const auth = getAuth(app)
export const db = getFirestore(app)

// 檢查是否在 Capacitor 環境中
const isCapacitorEnv = typeof window !== 'undefined' && (window as any).Capacitor !== undefined

// 初始化 Firebase Cloud Messaging（僅在支援的環境）
// 注意：iOS 模擬器和某些環境不支援 FCM
let messaging: ReturnType<typeof getMessaging> | null = null

// FCM 在以下情況不支援：
// - iOS 模擬器
// - Capacitor iOS（需要使用原生推播）
if (!isCapacitorEnv || (isCapacitorEnv && (window as any).Capacitor?.getPlatform() === 'web')) {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app)
    }
  }).catch(() => {
    // Ignore errors
  })
}

export { messaging }

// 啟用離線持久化（僅在非 Capacitor 環境）
// iOS WebView 對 IndexedDB 的支援有限，可能導致錯誤
if (!isCapacitorEnv) {
  enableIndexedDbPersistence(db).catch(() => {
    // Ignore persistence errors
  })
}
